import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f887dbd4"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["xlink:href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isShow)
    ? (_openBlock(), _createElementBlock("svg", {
        key: 0,
        class: _normalizeClass([_ctx.svgClass, "icon-style"]),
        "aria-hidden": "true",
        style: _normalizeStyle({ color: _ctx.color })
      }, [
        _createElementVNode("use", { "xlink:href": _ctx.iconName }, null, 8, _hoisted_1)
      ], 6))
    : _createCommentVNode("", true)
}